import React, { useState } from 'react';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Produkt } from './pages/Produkt';
import { Loesungen } from './pages/Loesungen';
import { Unternehmen } from './pages/Unternehmen';
import { Kontakt } from './pages/Kontakt';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home onNavigate={setCurrentPage} data-id="element-0" />;
      case 'product':
        return <Produkt onNavigate={setCurrentPage} data-id="element-1" />;
      case 'solutions':
        return <Loesungen onNavigate={setCurrentPage} data-id="element-2" />;
      case 'company':
        return <Unternehmen data-id="element-3" />;
      case 'contact':
        return <Kontakt data-id="element-4" />;
      default:
        return <Home onNavigate={setCurrentPage} data-id="element-5" />;
    }
  };
  return <Layout currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-6">
      {renderPage()}
    </Layout>;
}